import { Recognition } from 'models/recognition.model';

export const generateRecognitionRequestPayload = (recognition: Recognition) => {
  const {
    title,
    description,
    completedTasks,
    reward,
    stickerPackLink,
    feedbackFormLink,
    type,
    taskIds,
  } = recognition;

  let draftRecognition = {
    title,
    description,
    completedTasks: (+completedTasks || 0).toString(),
    reward: reward || 'NULL',
    type,
    taskIds,
  } as Omit<Recognition, 'id'>;

  if (reward === 'STICKER_PACK') {
    draftRecognition = {
      ...draftRecognition,
      stickerPackLink,
    };
  }

  if (reward === 'FEEDBACK_FORM') {
    draftRecognition = {
      ...draftRecognition,
      feedbackFormLink,
    };
  }

  return draftRecognition;
};
